import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  employeeNumber: { value: "", matchMode: "equals" },
  name: { value: "", matchMode: "contains" },
  jobTitle: { value: "", matchMode: "equals" },
  kmValueMonth: { value: "", matchMode: "equals"}
};

export const useFilterEmployeeTripsheetStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
